module.exports = __webpack_public_path__ + "static/media/icon_fold_off.2ca87cc3.svg";